export interface CompanyInfoStepState {
    cvrOrSENumber: string;
    companyName: string;
    companyCallingCode: string;
    companyPhoneNumber: string;
    postCode: string;
    city: string;
    address: string;
    emailForInvoicing: string;
    contactPersonName: string;
    contactPersonCallingCode: string;
    contactPersonPhoneNumber: string;
    contactPersonEmail: string;
    isCvr?: boolean;
    isSe?: boolean;
}

export interface CheckCVRSeNumberResponse {
    isValidCVR: boolean;
    isValidSE: boolean;
    seActiveObligationRegistrations: {
        aTax: boolean;
        labourMarketContribution: boolean;
        atp: boolean;
    };
}

export interface CreateCompanyRequestBody {
    cvrNumber: string;
    name1: string;
    name2: string;
    address: string;
    zipCode: string;
    city: string;
    phoneNumber: string;
    contactPerson: {
        fullName: string;
        phoneNumber: string;
        mobilePhoneNumber: string;
        email: string;
    };
    invoiceEmail: string;
    bankDetails: {
        registrationNumber: string;
        accountNumber: string;
    };
    customerType: CustomerType;
    administratorCompanyNumber: string;
    specialAgreement: string;
    vendorId: string;
    esvType: string;
    isSalaryAdministrationCustomer: boolean;
    subscriptionType: SubscriptionType;
}

// This is equal to the enum in the backend
export enum CustomerType {
    Company,
    SalaryPartner,
    Administrator,
    DepartmentDividedCompany,
}

// This is equal to the enum in the backend
export enum SubscriptionType {
    SalaryAdministration,
    SalaryPartner,
    BasisPlus,
    BasisPaper,
    Vip,
    Differentiated,
    Basis,
    Expert,
    SalaryPartner2,
    SalaryPartnerPlus,
    SalaryPartnerUnsubscribe,
}

export interface PayrollOnboardingContextType {
    onNext: () => void;
    setCompanyInfoStepState: React.Dispatch<React.SetStateAction<CompanyInfoStepState | undefined>>;
    setIsDialogLoading: React.Dispatch<React.SetStateAction<boolean>>;
    companyInfoStepState?: CompanyInfoStepState;
}

export interface BankAccountStepState {
    regNo: string;
    accountNo: string;
    contactName?: string;
    callingCode?: string;
    phoneNumber?: string;
    email?: string;
}

export interface GetCurrentCompanyBankInformationResponse {
    bankAccount: string;
    bankName: string;
    bankSortCode: string;
    fiCreditorNumber: string;
    giro: string;
    ibanNumber: string;
    pbsDebitorGroupNumber: number;
    pbsNumber: string;
    swiftCode: string;
}
